
import Icon from '../../components/bases/icone/icon';

import AppBase from '../appBase';
import ToolsBar from '../../components/bases/toolsbar/toolsbar';
import CommonErrors from './appcomponents/allsettings/commonerrors/commonerror.js';

import User from "./appcomponents/user/user.js"
import AppHeader from './appcomponents/appheader/appheader.js';
import SelectLanguage from '../../components/bases/selectlanguage/selectlanguage.js';
import UsersList from './tables/users/users.js';

import {getCurrentUserDatas} from "../../utils/software.js"


import styles from "../appstyles/styles.module.css"


import ftva from "../../assets/ftva.png"
import easytt from "../../assets/logoEasyTT.png"

import imgconfig from "./tables/assets/configurations.png"
import imgshortcuts from "./assets/toolsbar/shortcuts.png"
import imguser from "./tables/assets/users.png"


import React from "react";
import CommonRaccourcis from './appcomponents/allsettings/commonraccourcis/commonraccourcis.js';
import { keyboard_multi_savePersonnalKey } from '../../utils/keyboard_multi.js';



class AppAllSettings extends AppBase
{

    constructor (props)
    {
        super(props);
        
        const superuser = (getCurrentUserDatas().droits === 4);
        const bestuser = (getCurrentUserDatas().droits !== 1);

        this.state = {

          displayEditCommonErrors: false,
          displayEditCommonRaccourcis: false,
          displayUsers: false,

          toolsbar:
          { 
            height: 20,

            items: [
              {type:"space"},
              { img: imgconfig, type: "button", disable: !bestuser, fr: "Modifier la table des erreurs communes", en: "Modify common errors table", nochangecolor: false, key: { key: "COMMONERROR", cat: "applocalshortcut" } },
              {type:"space"},
              {img: imgshortcuts, type:"button", disable: false, fr:"Modifier la programmation des touches", en:"Edit programming keys", nochangecolor:false, key: {key: "COMMONSHORTCUTS", cat :"applocalshortcut"} },
              {type:"space"},
              {img: imguser, type:"button", disable: !superuser, fr:"Utilisateurs...", en:"Users", nochangecolor:false, key: {key: "USERS", cat :"applocalshortcut"} }
            ],
          }

        }

      this.appHeaderRef = React.createRef();
      this.commonRaccourcisRef = React.createRef();

      this.onClickToolsBar = this.onClickToolsBar.bind(this);
      this.onValidAllForm = this.onValidAllForm.bind(this)
      this.onClickCommonRaccourcis = this.onClickCommonRaccourcis.bind(this);

  
    }  


    canClose()
    {
      return true;
      
    }
    
    
    componentDidMount() {

    }
  



    // Suppression de l'écouteur lorsque le composant est démonté
    componentWillUnmount() {
    }  
      


  onClickToolsBar(datas)
  {
    
    switch (datas.cat)
    {
      case "applocalshortcut":
        switch (datas.key) {
          case "COMMONERROR":
            this.setState({ displayEditCommonErrors: true })
            break;
          
          case "COMMONSHORTCUTS":
            this.setState({ displayEditCommonRaccourcis: true });
            return;

          case "USERS":
            this.setState({ displayUsers: true });
            return;

          }        
    }
  }



  onValidAllForm(ret)
  {
      this.setState({displayEditCommonErrors: false, displayUsers:false, displayEditCommonRaccourcis:false})

  }

  onClickCommonRaccourcis(event) {
    switch (event.name) {
      case 'back':
        this.setState({ displayEditCommonRaccourcis: false });
        break;
        
      case 'save':
        keyboard_multi_savePersonnalKey(event.items);
        this.setState({ displayEditCommonRaccourcis: false });
        break;
        
      default:
        return;
    }  
  }

 
  render ()
  {
    

    const title = this.context.language=="fr"?"PARAMETRES":"SETTINGS"
    
    var addwindows = []
    if (this.state.displayEditCommonErrors) {
      addwindows.push(<CommonErrors display={this.state.displayEditCommonErrors} onButton={this.onValidAllForm} />)
    }

    if (this.state.displayEditCommonRaccourcis) {
      addwindows.push(<CommonRaccourcis key="raccourcis" ref={this.commonRaccourcisRef} display={this.state.displayEditCommonRaccourcis} onButton={this.onClickCommonRaccourcis} />)
    }
  
    if (this.state.displayUsers){
      addwindows.push(            
      <UsersList 
              onvalidform={this.onValidAllForm} 
              closebutton = {true} zindex={1} 
              display = {true} select={true} edit={true}
              project={0}
              pjuser={0}
        />
      )
    }


    return (
      <>
      <div className={styles.appDiv}>
        <div className={styles.appDivTop}>
          <div className={styles.appDivLogoFtva}>
              <img src={ftva} style = {{width:"100%", verticalAlign:"middle"}}/>
          </div>
          <div className={styles.appDivProject}>
              <div className={styles.appDivProjectLeft}>
              <h1>{title}</h1>
              </div>
              <div className={styles.appDivProjectRight}>
              <AppHeader ref={this.appHeaderRef} canclose={true}/>
              </div>

          </div>
          <div className={styles.appDivLogo}>
          <Icon image={easytt} height="100%" width="100%"/>
          </div>
          <div className={styles.appDivLanguage}>
             <SelectLanguage/>
          </div>
          <div className={styles.appDivUser}>
              <User onnavigate = {this.props.onnavigate} onCancelKeyboardEvent={this.onCancelKeyboardEvent}/>
          </div>
        </div>
        <div className={styles.appDivToolsBar}>
            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar}/>
        </div>
        <div className={styles.appDivBody} ref = {this.bodyDivRef}>
      <div className={styles.appPanelsContainerRow}>


          </div>
              
          
          </div>
          
      </div>
      {addwindows}
      </>
    
    )
    }
}


export default AppAllSettings;
